<template>
	<div v-if="event">
		<div class="card" v-if="!loading && event.ticketGroups.length == 0">
			<div class="card-body text-center py-4">
				<h5>No se han creado entradas</h5>
				<p>Añade entradas para comenzar a vender el evento</p>

				<div @click="$refs.eventTicketGroupModal.open()" class="btn btn-primary mt-2">
					Crear tipo de entrada
				</div>
			</div>
		</div>

		<div class="card" v-if="!loading && event.ticketGroups.length > 0">
			<div class="card-body p-3">
				<table class="table table-clickeable">
					<tr class="table-head">
						<td>Tipos de entradas</td>
						<td class="text-center">Precio</td>
						<td>Ventas</td>
						<td class="text-right">Ingresos</td>
						<td></td>
					</tr>

					<template v-for="(group, index) in event.ticketGroups">
						<tr :key="index">
							<td>
								<div class="tc">
									<strong>{{ group.name }}</strong>
									<span>Disponibles hasta: {{ group.sellAt | moment("DD-MM-YYYY HH:mm") }}</span>
								</div>
							</td>
							<td></td>
							<td>
								<div class="px-2">
									<b-progress :value="group.ticketsSoldPercent" :max="100" height="8px"></b-progress>
									<div class="d-flex justify-content-between stats-detail">
										<div>
											<h5>{{ group.ticketsSold }} vendidas</h5>
											<span class="text-secondary">de {{ group.ticketsLimit }}</span>
										</div>
										<div class="text-right">
											<h5>{{ group.ticketsAvailable }}</h5>
											<span class="text-secondary">disponibles</span>
										</div>
									</div>
								</div>
							</td>
							<td>
								<div class="tc">
									<h4 class="main-total">
										{{ group.currencySymbol }} {{ group.totalSales | toCurrency }}
									</h4>
								</div>
							</td>
							<td class="text-right">
								<div class="tc justify-content-end">
									<b-dropdown no-caret right class="dropdown-dots" v-if="event.canEdit">
										<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
										<b-dropdown-item @click="clickBox(group)">Editar</b-dropdown-item>
										<!-- <b-dropdown-item @click="deletePrompt(item)" class="delete-item">
										<i class="icon icon-trashcan"></i> Eliminar
									</b-dropdown-item> -->
									</b-dropdown>
								</div>
							</td>
						</tr>
						<template v-for="ticket in group.ticketTypes">
							<tr :key="ticket.id" @click="clickBox(group)">
								<td>
									<div class="tc">
										<div class="child-arrow"></div>
										{{ ticket.name }}
									</div>
								</td>
								<td>
									<div class="tc">
										<div class="w-100 text-center">
											<strong
												>{{ ticket.currencySymbol }} {{ ticket.priceUnit | toCurrency }}</strong
											>
										</div>
									</div>
								</td>
								<td>
									<div class="px-2">
										<b-progress :max="ticket.ticketsLimit" height="6px">
											<b-progress-bar
												:value="ticket.ticketsSold"
												variant="success"
											></b-progress-bar>
											<b-progress-bar
												:value="ticket.ticketsCourtesy"
												variant="info"
												v-b-tooltip.hover
												:title="`Cortesías: ${ticket.ticketsCourtesy}`"
											></b-progress-bar>
											<b-progress-bar
												:value="ticket.ticketsReserved"
												variant="warning"
											></b-progress-bar>
										</b-progress>
										<div class="d-flex justify-content-between stats-detail">
											<div>
												<h5>{{ ticket.ticketsSold }} vendidas</h5>
												<span class="text-secondary">de {{ ticket.ticketsLimit }}</span>
											</div>
											<div class="text-right">
												<h5>{{ ticket.ticketsAvailable }}</h5>
												<span class="text-secondary">disponibles</span>
											</div>
										</div>
									</div>
								</td>
								<td>
									<div class="tc">
										<h4 class="main-total">
											{{ ticket.currencySymbol }} {{ ticket.totalSales | toCurrency }}
										</h4>
									</div>
								</td>
								<td></td>
							</tr>
						</template>
					</template>
				</table>

				<div class="d-flex justify-content-end mt-4" v-if="canCreate && event.canEdit">
					<div @click="$refs.eventTicketGroupModal.open()" class="btn btn-primary mt-2">
						Crear tipo de entrada
					</div>
				</div>
			</div>
		</div>

		<EventTicketGroupModalForm ref="eventTicketGroupModal" :event="event" @updated="load()" />
	</div>
</template>
<script>
import gql from "graphql-tag"
import EventTicketGroupModalForm from "./forms/EventTicketGroupModalForm"

export default {
	name: "EventTicketGroups",
	components: {
		EventTicketGroupModalForm
	},
	props: {
		eventId: {
			type: String,
			required: true
		},
		canCreate: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			event: null,
			loading: false
		}
	},
	async beforeMount() {
		await this.load()
	},
	methods: {
		clickBox(type) {
			if (this.event.canEdit) this.$refs.eventTicketGroupModal.open(type)
		},

		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								startAt
								endAt
								canEdit
								ticketGroups {
									id
									name
									ticketsSold
									ticketsLimit
									totalSales
									currencySymbol
									ticketsSoldPercent
									ticketsAvailable
									minPerOrder
									maxPerOrder
									validAt
									sellAt
									holderRequired

									statusText
									statusClass
									ticketTypes {
										id
										name
										ticketsReserved
										ticketsCourtesy
										ticketsSold
										ticketsSoldPercent
										ticketsLimit
										totalSales
										ticketsAvailable
										currencySymbol
										priceUnit
									}
								}
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.event = {
						...data.event,
						ticketGroups: data.event.ticketGroups.map((e) => {
							return {
								...e,
								validAtFormatted: this.$moment(e.validAt).format("dddd DD [de] MMM YYYY [a las] HH:mm")
							}
						})
					}
					return data.event
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.stats-detail {
	font-size: 0.8rem;
	line-height: 0.9rem;
	h5 {
		font-size: 0.8rem;
	}
}
.main-total {
	font-size: 1rem;
	text-align: right;
	width: 100%;
}

.child-arrow {
	width: 14px;
	height: 14px;
	border: #e2e8f0 solid 1px;
	border-radius: 0px 0px 0px 4px;
	border-right: none;
	border-top: none;
	display: inline-flex;
	margin-top: -12px;
	margin-right: 6px;
}
</style>
